import React from 'react';
import FacebookImageArrow from '../../../assets/social-media-preview/facebook-image-arrow.svg';
import FacebookLinkArrow from '../../../assets/social-media-preview/facebook-link-arrow.svg';
import FacebookPost from '../../../assets/social-media-preview/facebook.png';
import { useTranslations } from '../../../utils/translations';
import {
    HideOnMobile,
    ImgArrow,
    ImgArrowText,
    LinkArrow,
    LinkArrowText,
    PreviewArrowsContainer,
    PreviewContainer,
    PreviewImage,
    PreviewTitle,
} from './style';

export const Preview: React.FCC = () => {
    const { preview } = useTranslations('socialMediaGiving.facebook.page', {
        preview: ['title', 'imageDesc', 'linkDesc'],
    });

    return (
        <PreviewContainer>
            <div>
                <PreviewTitle variant="caption1">{preview.title}</PreviewTitle>
                <PreviewImage
                    alt="facebook"
                    src={FacebookPost}
                    title="facebook"
                />
            </div>
            <PreviewArrowsContainer>
                <HideOnMobile>
                    <ImgArrowText variant="caption1">
                        {preview.imageDesc}
                    </ImgArrowText>
                    <ImgArrow
                        alt={preview.imageDesc}
                        src={FacebookImageArrow}
                        title="indicator arrow"
                    />
                    <LinkArrow
                        alt={preview.linkDesc}
                        src={FacebookLinkArrow}
                        title="indicator arrow"
                    />
                    <LinkArrowText variant="caption1">
                        {preview.linkDesc}
                    </LinkArrowText>
                </HideOnMobile>
            </PreviewArrowsContainer>
        </PreviewContainer>
    );
};
